/*
==========================================================
Project : ChemMaster SA
File    : ResetPassword.js
Version : 1.0
Purpose : Allows a learner to choose a new password using
          the secure token received by email.
==========================================================
*/

import { useState } from "react";
import branding from "./branding";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000/api";

function ResetPassword() {
  const [newPassword, setNewPassword] =
    useState("");

  const [
    confirmPassword,
    setConfirmPassword,
  ] = useState("");

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const token =
    new URLSearchParams(
      window.location.search
    ).get("token");

  const handleResetPassword = async () => {
    if (!token) {
      alert(
        "The password-reset link is missing its secure token."
      );
      return;
    }

    if (
      !newPassword ||
      !confirmPassword
    ) {
      alert(
        "Please complete both password fields."
      );
      return;
    }

    if (newPassword.length < 8) {
      alert(
        "Your new password must contain at least 8 characters."
      );
      return;
    }

    if (
      newPassword !== confirmPassword
    ) {
      alert(
        "The two passwords do not match."
      );
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await fetch(
        `${API_BASE_URL}/auth/reset-password`,
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json",
          },

          body: JSON.stringify({
            token,
            newPassword,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(
          data.message ||
          "The password could not be reset."
        );
        return;
      }

      alert(
        "Your password has been reset successfully."
      );

      window.location.href = "/";
    } catch (error) {
      console.error(
        "Password reset request failed:",
        error
      );

      alert(
        "The password could not be reset. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f3f6fb",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "40px",
          borderRadius: "15px",
          width: "100%",
          maxWidth: "400px",
          boxShadow:
            "0 4px 15px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src="/ScienceTutor.png"
            alt="Science Tutor logo"
            style={{
              width: "190px",
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </div>

        <h1
          style={{
            textAlign: "center",
            color:
              branding.primaryColor,
          }}
        >
          Reset Password
        </h1>

        <input
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={(event) =>
            setNewPassword(
              event.target.value
            )
          }
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "20px",
            boxSizing: "border-box",
          }}
        />

        <input
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(event) =>
            setConfirmPassword(
              event.target.value
            )
          }
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "15px",
            boxSizing: "border-box",
          }}
        />

        <button
          type="button"
          onClick={
            handleResetPassword
          }
          disabled={isSubmitting}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "20px",
            background:
              isSubmitting
                ? "#9ca3af"
                : branding.primaryColor,
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor:
              isSubmitting
                ? "not-allowed"
                : "pointer",
          }}
        >
          {isSubmitting
            ? "Resetting..."
            : "Reset Password"}
        </button>
      </div>
    </div>
  );
}

export default ResetPassword;